import React from "react";
import { Button } from "reactstrap";

const Btn = (props) => {
  //   console.log("Button props", props);
  return <Button {...props.attrBtn}>{props.children}</Button>;
};

export default Btn;
